// extracted by mini-css-extract-plugin
export default {"wrapper":"TableLoader_wrapper__Hh+UN"};